export default __webpack_public_path__ + "static/media/1.514f70f3.png";